module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/52I7loFMRAyWurhgobYSb3-08036c0eb8dc0b17f08fcf7eca18e2c8.jpg";